import React from 'react'
import styled from 'styled-components'
import { Chip } from '@mui/material'

import { useRateQuery } from '../hooks'
import { Loader } from '../../../Loader'
import { IconButton } from '../../../components/Styleguide/Button'

interface RatingControlsProps {
  rating: number
  explanation: string
  disableRating?: boolean
  descriptor: { day: string; queryId: string }
}

export const RatingControls: React.FC<RatingControlsProps> = ({
  rating,
  descriptor,
  explanation,
  disableRating
}) => {
  const { rateQuery, statusFlags } = useRateQuery()

  if (statusFlags.isLoading || (rating === 0 && statusFlags.isSuccess)) {
    return (
      <Wrapper>
        <Loader size="small" />
      </Wrapper>
    )
  }

  const chipStyle = {
    ...{ color: '#333', fontSize: '14px' },
    backgroundColor: rating === 1 ? '#d4f8e8' : rating === -1 ? '#f8d4d4' : ''
  }

  if (explanation !== '' && rating !== 0) {
    return (
      <Wrapper>
        <Chip
          style={chipStyle}
          label={rating + '*'}
          onClick={() => explanation && alert(explanation)}
        />
      </Wrapper>
    )
  }

  if (rating === 0 && !disableRating) {
    return (
      <Wrapper>
        <Button
          disabled={rating !== 0}
          iconName="thumbs-up"
          onClick={() => rateQuery({ ...descriptor, rating: true })}
        />
        <Button
          disabled={rating !== 0}
          iconName="thumbs-down"
          tooltipText={explanation}
          onClick={() => rateQuery({ ...descriptor, rating: false })}
        />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Chip label={rating} style={chipStyle} />
    </Wrapper>
  )
}

const Button = styled(IconButton)`
  margin: 0px 5px 0px 0px;
  border-radius: 32px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
